export default __webpack_public_path__ + "static/media/green-headphone.16b20732.png";